import http from '@/utils/http'
import { auth } from '@/api/url'

// 提交公司信息认证
export function addCompRegMaterial(param) {
  return http({
    url: auth.addCompRegMaterial,
    method: 'post',
    data: { ...param }
  })
}

// 更新公司信息认证
export function updateCompRegInfo(param) {
  return http({
    url: auth.updateCompRegInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取股东信息
export function getCompShareholderInfo(param) {
  return http({
    url: auth.getCompShareholderInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取业务信息
export function getBusinessInfo(param) {
  return http({
    url: auth.getBusinessInfo,
    method: 'post',
    data: { ...param }
  })
}

// 更改业务信息
export function updateBusinessInfo(param) {
  return http({
    url: auth.updateBusinessInfo,
    method: 'post',
    data: { ...param }
  })
}

// 添加业务信息
export function addBusinessInfo(param) {
  return http({
    url: auth.addBusinessInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取总预览
export function submitCompKycInfo(param) {
  return http({
    url: auth.submitCompKycInfo,
    method: 'post',
    data: { ...param }
  })
}

// 提交总预览
export function getCompKycInfo(param) {
  return http({
    url: auth.getCompKycInfo,
    method: 'post',
    data: { ...param }
  })
}

// 新增股东信息
export function addCompanyShareholderInfo(param) {
  return http({
    url: auth.addCompanyShareholderInfo,
    method: 'post',
    data: { ...param }
  })
}

// 更新股东信息
export function updateCompShareholderInfo(param) {
  return http({
    url: auth.updateCompShareholderInfo,
    method: 'post',
    data: { ...param }
  })
}

// 提交个人认证
export function addPersonRegInfo(param) {
  return http({
    url: auth.addPersonRegInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取个人认证
export function getPersonRegInfo(param) {
  return http({
    url: auth.getPersonRegInfo,
    method: 'post',
    data: { ...param }
  })
}

// 修改个人认证
export function updatePersonRegInfo(param) {
  return http({
    url: auth.updatePersonRegInfo,
    method: 'post',
    data: { ...param }
  })
}

// 个人总预览
export function getIndividualMaterial(param) {
  return http({
    url: auth.getIndividualMaterial,
    method: 'post',
    data: { ...param }
  })
}

// 获取企业认证,注册人信息
export function getCompRegInfo(param) {
  return http({
    url: auth.getCompRegInfo,
    method: 'post',
    data: { ...param }
  })
}

// 提交企业信息材料
export function addCompanyInfo(param) {
  return http({
    url: auth.addCompanyInfo,
    method: 'post',
    data: { ...param }
  })
}

// 更新企业信息材料
export function updateCompanyInfo(param) {
  return http({
    url: auth.updateCompanyInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取企业信息材料
export function getCompanyInfo(param) {
  return http({
    url: auth.getCompanyInfo,
    method: 'post',
    data: { ...param }
  })
}

// 获取dashboard步骤
export function getKycInfo(param) {
  return http({
    url: auth.getKycInfo,
    method: 'post',
    data: param
  })
}

// 上传协议文件
export function addAgreementFile(param) {
  return http({
    url: auth.addAgreementFile,
    method: 'post',
    data: { ...param }
  })
}

// 获取协议文件
export function getAgreementInfo(param) {
  return http({
    url: auth.getAgreementInfo,
    method: 'post',
    data: { ...param }
  })
}

// 添加银行卡
export function addBankAcct(param) {
  return http({
    url: auth.addBankAcct,
    method: 'post',
    data: { ...param }
  })
}

// 获取银行卡
export function getBankAcct(param) {
  return http({
    url: auth.getBankAcct,
    method: 'post',
    data: { ...param }
  })
}

// 更新银行卡
export function updateBankAcct(param) {
  return http({
    url: auth.updateBankAcct,
    method: 'post',
    data: { ...param }
  })
}

// 推荐信息列表查询
export function getReferrerList(param) {
  return http({
    url: auth.getReferrerList,
    method: 'post',
    data: { ...param }
  })
}

// 修改备注
export function updateRemark(param) {
  return http({
    url: auth.updateRemark,
    method: 'post',
    data: { ...param }
  })
}
// 首页累计指标
export function homeOverview(param) {
  return http({
    url: auth.homeOverview,
    method: 'post',
    data: { ...param }
  })
}
// 开户转化率折线
export function openAcctConversionTrend(param) {
  return http({
    url: auth.openAcctConversionTrend,
    method: 'post',
    data: { ...param }
  })
}
// 支付交易趋势折线
export function payTrend(param) {
  return http({
    url: auth.payTrend,
    method: 'post',
    data: { ...param }
  })
}
// 收款交易趋势折线
export function transinTrend(param) {
  return http({
    url: auth.transinTrend,
    method: 'post',
    data: { ...param }
  })
}

